<template>
  <div>
    <el-card
      header="Key Fields"
      shadow="never"
    >
      <p>
        <b>Name: </b>
        <span>{{ $_.get(carrier, 'name') || '-' }}</span>
      </p>
      <p>
        <b>Shipping Code: </b>
        <span>{{ $_.get(carrier, 'chainit') || '-' }}</span>
      </p>
      <p>
        <b>Address: </b>
        <span>{{ $_.get(carrier, 'address') || '-' }}</span>
      </p>
      <p>
        <b>Town: </b>
        <span>{{ $_.get(carrier, 'town') || '-' }}</span>
      </p>
      <p>
        <b>State: </b>
        <span>{{ $_.get(carrier, 'state') || '-' }}</span>
      </p>
      <p>
        <b>Postcode: </b>
        <span>{{ $_.get(carrier, 'postcode') || '-' }}</span>
      </p>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    carrier: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>

</style>
